import { Component, ViewChild, OnInit, ElementRef, Output, EventEmitter } from '@angular/core';//include the output and eventemitter to pass values from child to parent
import { Routes, RouterModule, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import * as ngswal from "sweetalert";
import { GlobalConstants } from '../../common/global-constants';
import { customfunctions, DataParam } from '../../common/customfunctions';
import { catchError, retry } from 'rxjs/operators';
import { ApiMethod } from '../../apimethods/api-method';
import { ViewportScroller } from '@angular/common';
import { HttpClient } from '@angular/common/http';


declare var $;

@Component({
  selector: 'app-master-grid',
  templateUrl: './master-grid.component.html',
  styleUrls: ['./master-grid.component.css']
})
/** MasterGrid component*/
export class MasterGridComponent implements OnInit {

  @Output() newItemEvent = new EventEmitter<{ journal: string, defectstatus: string }>();
  showModal: boolean;
  title: string;
  dataTable: any;
  dtOptions: any;
  tableData = [];
  ajournalCt = [];
  aARCount: any;
  showStatus: any = 'IRstatus' // set by the parent component
  @ViewChild('dataTable', { static: false }) table;

  dataSet: any;
  ajournalAccess: any;

  showColumn: boolean = true;


  constructor(private router: Router, http: HttpClient) {

  }
  ngOnInit(): void {

    this.getJournalCount();
    this.checkAccess();
  }

  checkAccess(): void {
    {
      var paramData = {
        PublisherID: localStorage.aPubID,
        LoginID: localStorage.aLoginID


      };
      ApiMethod.postMethod('api/journalAccess', paramData).subscribe(
        Response => {
          console.log(Response);
          const userCount = Response.userCount;
          if (userCount.length > 0) {
            this.ajournalAccess = userCount[0].Action;
            
          }

          if (this.ajournalAccess == 'Response') {
            this.showColumn = false;

          } else {

            this.showColumn = true;

          }
          
        }, error => {

          ngswal("Failed !", error.message, "error");
        }
      );

    }

  }

  addNewItem(journal, defectstatus) {
    this.newItemEvent.emit({ journal, defectstatus });
  }


  hide(): void {
  }

  getJournalCount(): void {
    $("#LoadingImage").show();
    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID

    };

    ApiMethod.postMethod('api/journalCount', paramData).subscribe(
      Response => {
        this.ajournalCt = Response.journalCount;
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      }
    );

  }


  getJournalCountAR(): void {
    $("#LoadingImage").show();
    var paramData = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID

    };

    ApiMethod.postMethod('api/journalCountAR', paramData).subscribe(
      Response => {

        this.ajournalCt = Response.journalCount;
        $("#LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      }
    );

  }

}
